<template>
  <a-modal
    :maskClosable="false"
    :visible="visible"
    title="调整额度"
    :footer="false"
    :width="850"
    @cancel="handleCancel"
  >
    <!-- 查询 -->
    <a-form
      class="reduceForm"
      :form="form"
      :layout="formLayout"
      @submit="handleSubmit"
    >
      <a-row>
        <a-col :sm="mediaLayout.sm" :md="mediaLayout.md" :lg="mediaLayout.lg">
          <a-form-item label="最终批复额度:">
            <span>{{ crtItem && crtItem.reviewAmount | formatAmount }}</span>
          </a-form-item>
        </a-col>
        <a-col :sm="mediaLayout.sm" :md="mediaLayout.md" :lg="mediaLayout.lg">
          <a-form-item label="调减后额度">
            <a-input v-decorator="['reducedAmount']" />
          </a-form-item>
        </a-col>
        <a-col :sm="mediaLayout.sm" :md="mediaLayout.md" :lg="mediaLayout.lg">
          <a-form-item label="到期日:">
            <span>{{ crtItem && crtItem.indateEnd }}</span>
          </a-form-item>
        </a-col>
        <a-col :sm="mediaLayout.sm" :md="mediaLayout.md" :lg="mediaLayout.lg">
          <a-form-item label="调减后到期日">
            <a-date-picker
              :format="format"
              :valueFormat="format"
              v-decorator="['reducedDate']"
            ></a-date-picker>
          </a-form-item>
        </a-col>
        <a-col
          v-if="crtItem && crtItem.creditTypeStr == '信用限额'"
          :sm="mediaLayout.sm"
          :md="mediaLayout.md"
          :lg="mediaLayout.lg"
        >
          <a-form-item label="限额条件:">
            <span v-if="crtItem && crtItem.limitConditionType">
              Net AR 超 {{ crtItem && crtItem.limitConditionAmount }}元控货
            </span>
            <span v-else>无</span>
          </a-form-item>
        </a-col>
        <a-col
          v-if="crtItem && crtItem.creditTypeStr == '信用限额'"
          :sm="mediaLayout.sm"
          :md="mediaLayout.md"
          :lg="mediaLayout.lg"
        >
          <a-form-item label="调整后限额条件">
            <a-select
              style="width: 110px;"
              v-decorator="['limitConditionType']"
              @change="value => (limitConditionType = value)"
              :options="LIMIT_CONDITION_TYPE_LIST"
            ></a-select>
            <div v-if="limitConditionType == 1">
              <a-form-item label="Net AR超 ">
                <!-- <span>Net AR超</span> -->
                <a-input
                  size="small"
                  style="width:60px;margin-left: 10px; font-size: 12px;"
                  v-decorator="[
                    'limitConditionAmount',
                    { rules: [{ required: true, message: '请输入控货金额' }] },
                  ]"
                />
                <span>元控货</span>
              </a-form-item>
            </div>
          </a-form-item>
        </a-col>
        <a-col :sm="mediaLayout.sm" :md="mediaLayout.md" :lg="mediaLayout.lg">
          <a-form-item label="账期:">
            <span>{{ crtItem && crtItem.term }}</span>
          </a-form-item>
        </a-col>
        <a-col :sm="mediaLayout.sm" :md="mediaLayout.md" :lg="mediaLayout.lg">
          <a-form-item label="调整后账期">
            <a-input v-decorator="['term']" />
          </a-form-item>
        </a-col>
      </a-row>
      <a-col :sm="mediaLayout.sm" :md="mediaLayout.md" :lg="mediaLayout.lg">
        <a-form-item label="备注:">
          <a-textarea
            placeholder="100个字符以内"
            v-decorator="[
              'reducedRemark',
              {
                rules: [{ required: true, message: '请输入备注!' }],
              },
            ]"
            allow-clear
          />
        </a-form-item>
      </a-col>
      <div class="center margin-bottom-20">
        <a-form-item :wrapper-col="{ span: 12, offset: 5 }">
          <a-button type="primary" html-type="submit">
            确定
          </a-button>
        </a-form-item>
      </div>
    </a-form>
    <!-- 结果 -->
    <TableView
      :loading="loading"
      ref="table"
      :columns="columns"
      size="small"
      :pagination="pageData"
      :data="tableData"
      v-on:handlePagination="handlePagination"
    >
      <template v-slot:targetTerm="{ tableRow }">
        <template>
          {{ tableRow.targetTerm }}
        </template>
      </template>
      <!--调整后额度-->
      <template v-slot:amount="{ tableRow }">
        <template v-if="Number(tableRow.amount) === 0">
          {{ tableRow.amount }}
        </template>
        <template v-else>{{ tableRow.amount | formatAmount }}</template>
      </template>
      <!--调整后限额条件-->
      <template v-slot:limitConditionAmount="{ tableRow }">
        <template v-if="!tableRow.limitConditionAmount">
          {{ tableRow.limitConditionAmount }}
        </template>
        <template v-else>
          {{ tableRow.limitConditionAmount | formatAmount }}
        </template>
      </template>
      <!--备注-->
      <template v-slot:remark="{ tableRow }">
        <a-tooltip placement="topLeft">
          <template slot="title">
            <span>{{ tableRow.remark }}</span>
          </template>
          <span>{{ tableRow.remark }}</span>
        </a-tooltip>
      </template>
    </TableView>
  </a-modal>
</template>
<script>
import { TableView } from 'lxfintech-fe'
import { creditReduce, pageReduced } from '../api'
import mixin from './mixin'
export default {
  mixins: [mixin],
  components: {
    TableView,
  },
  data() {
    return {
      validateRulesObj: {
        //自定义校验规则
        limitConditionType: {
          rules: [
            {
              required: true,
              validator: (rule, value, cbfn) => {
                if (!value) {
                  cbfn('请输入控货金额')
                }
              },
            },
          ],
        },
      },
      LIMIT_CONDITION_TYPE_LIST: [
        {
          label: '无',
          value: 0,
        },
        {
          label: '控货',
          value: 1,
        },
      ],
      creditAmount: {
        totalCreditLimit: '',
      },
      loading: false,
      formLayout: 'inline',
      tableData: [],
      form: this.$form.createForm(this, { name: 'createForm' }),
      limitConditionType: '',
      visible: false,
      tableRow: {},
      crtItem: {},

      companyCode: '',
      format: 'YYYY-MM-DD',
      mediaLayout: {
        sm: 24,
        md: 12,
        lg: 12,
      },
    }
  },
  mounted() {},
  methods: {
    // 新增
    add(row, code, creditAmount) {
      this.visible = true
      this.crtItem = row
      this.creditAmount = creditAmount
      this.limitConditionType = ''

      this.form.resetFields()
      this.tableRow = {}
      this.checkedKeys = []
      this.id = ''
      this.companyCode = code
      this._pageReduced()
    },
    // 维护
    edit(tableRow) {
      this.visible = true
      this.tableRow = tableRow
      const { id, permissionIds } = tableRow
      this.id = id
      this.checkedKeys = permissionIds
    },
    // 取消
    handleCancel() {
      this.visible = false
      // parent.location.reload()
      // location.reload();
    },
    // 提交数据
    handleSubmit(e) {
      try {
        // console.log(this.crtItem)
        // console.log(this.creditAmount)
        e.preventDefault()
        this.form.validateFields(async (err, values) => {
          if (!err) {
            // 限额条件为无
            if (this.crtItem.limitConditionType == 0) {
              if (
                this.creditAmount.totalCreditLimit < values.limitConditionAmount
              ) {
                this.$warning({
                  title: '提示',
                  content: '调整后限额条件只支持调减',
                })
                return
              }
            }
            // 有限额条件
            else {
              //
              if (this.limitConditionType == 1) {
                if (
                  this.crtItem.limitConditionAmount <
                  values.limitConditionAmount
                ) {
                  this.$warning({
                    title: '提示',
                    content: '调整后限额条件只支持调减',
                  })
                  return
                }
              }
              // else if (this.limitConditionType == 0) {
              //   if (this.crtItem.limitConditionAmount > 10000) {
              //     this.$warning({
              //       title: '提示',
              //       content: '调整后限额条件只支持调减'
              //     })
              //     return
              //   }
              // }
            }
            let data = Object.assign({}, values)
            await this._creditReduce(data)
            this.$emit('getTableData')
          }
        })
      } catch (error) {
        console.error(error)
      }
    },
    async _creditReduce(data) {
      var params = data
      params.id = this.crtItem.id
      try {
        const { message } = await creditReduce(params)
        this.$message.success(message || '调减成功')
        this._pageReduced()
      } catch (err) {
        console.log(err)
      }
    },
    //分页
    handlePagination(pagination) {
      const { current, pageSize, total } = pagination
      this.pageData.current = current
      this.pageData.pageSize = pageSize
      this.pageData.total = total
      this._pageReduced()
    },
    _pageReduced() {
      this.loading = true
      const { current, pageSize } = this.pageData
      const query = {
        id: this.crtItem.id,
        size: pageSize,
        current,
      }
      delete query.times
      delete query.pageSize

      pageReduced(query).then(({ data: { total, records } }) => {
        this.loading = false
        this.tableData = records
        this.pageData.total = total
      })
    },
  },
}
</script>
<style lang="less" scoped>
/deep/ .center {
  text-align: center;
}
/deep/ .margin-bottom-20 {
  margin-bottom: 20px;
}
/deep/ .reduceForm {
  width: 90%;
  margin: 0 auto;
}
/deep/ .ant-col {
  margin-bottom: 10px;
}
/deep/ .ant-form-item {
  width: 100%;
}
/deep/ .ant-form-item-label {
  width: 30%;
}
/deep/ .ant-form-item-control-wrapper {
  width: 60%;
}
/deep/ .ant-form-item-children,
.ant-calendar-picker {
  width: 100%;
}
/deep/ .ant-form-item-label {
  width: 36%;
}
</style>
